<template>
  <div class="createTaskForm">
    <form
        class="forms-sample"
        style="border-radius: 10px; border: 1px solid gainsboro"
        id="form-modal"
        @submit.prevent="submitForm"
    >
      <h5 class="createTaskHeading">What Needs to be Done?</h5>
      <div class="form-row">
        <div class="form-group col-12">
          <label for="title">Title</label>
          <input type="text" v-model="task.title" class="form-control" id="title"/>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6 col-12">
          <label class="form-label">Due Date<span class="required text-danger">*</span>:</label>
          <input type="datetime-local" v-model="task.due_date" class="form-control" placeholder="Due Date"/>
        </div>
        <div class="form-group col-md-6 col-12">
          <label class="form-label">Assign To<span class="required text-danger">*</span>:</label>
          <multiselect
              :options="assignTo"
              :allow-empty="true"
              :searchable="true"
              :multiple="false"
              :selectedLabel="null"
              :deselectLabel="null"
              :selectLabel="null"
              label="user_name"
              track-by="id"
              v-model="task.assigned_to_selected"
              :loading="loading"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-12">
          <label for="title">Description</label>
          <div class="text_editor">
            <tiny-mce-editor :vModelName.sync="task.description" :media="false"></tiny-mce-editor>
            <br/>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button class="btn addTaskSubmit">
          <i class="fas fa-plus" v-if="!editMode"></i>
          <img :src="updateIcon" v-else>
          {{ editMode ? "Update Task" : "Add Task" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment/moment";
import UpdateIcon from '@/assets/images/tick-white.svg'
import TinymceEditor from "@/views/partials/tiny_mce_editor.vue";

export default {
  name: "createTasks",
  components: {"tiny-mce-editor": TinymceEditor, Multiselect},
  props: ['editMode', 'taskId'],
  data() {
    return {
      task: {
        id: null,
        title: "",
        description: "",
        due_date: "",
        assigned_to_selected: null,
        lead_id: this.$route.params.id
      },
      loading: false,
      editData: {},
      updateIcon: UpdateIcon,
    };
  },
  computed: {
    assignTo() {
      return this.$store.getters["users/assignToUser"];
    }
  },
  created() {
    if (this.editMode) {
      this.fetchTaskData();
    }
  },
  mounted() {

  },
  methods: {
    fetchTaskData() {
      this.$store.dispatch("quick_task/edit", [this.taskId]).then(response => {
        this.editData = response;
        this.initializeEditData();
      });
    },
    initializeEditData() {
      if (this.editData) {
        this.task.id = this.editData.id;
        this.task.title = this.editData.title || "";
        this.task.description = this.editData.description || "";
        this.task.due_date = moment(
            `${this.editData.due_date} ${this.editData.time}`
        ).format("YYYY-MM-DD HH:mm");
        // this.task.due_date = moment(this.editData.due_date).format("YYYY-MM-DDTHH:mm") || "";
        this.task.assigned_to_selected = this.editData.assigned_to ? {
          user_name: this.editData.assigned_to.user_name,
          id: this.editData.assigned_to.id
        } : null;
      }
    },
    validateForm() {
      if (!this.task.title || !this.task.description || !this.task.assigned_to_selected || !this.task.due_date) {
        this.$toast.error("Please fill in the required fields.");
        return false;
      }
      return true;
    },
    resetForm() {
      this.task = {
        id: null,
        title: "",
        description: "",
        due_date: "",
        assigned_to_selected: null
      };
    },
    submitForm() {
      if (!this.validateForm()) return;
      this.loading = true;
      const method = this.editMode ? "update" : "add";
      this.task.assigned_to = this.task.assigned_to_selected.id;
      this.$store.dispatch(`quick_task/${method}`, this.task)
          .then(response => {
            this.loading = false;
            if (response && response.error) {
              this.$toast.error(response.error);
            } else {
              if (this.editMode) {
                this.$toast.success("Task updated successfully.");
              } else {
                this.$toast.success("Task saved successfully.");
              }

              this.resetForm();
              this.refreshTasks();
              this.$emit("updateTaskTabValue", true);
            }
          })
          .catch(() => {
            this.loading = false;
            this.$toast.error("An error occurred while saving the task.");
          });
    },
    refreshTasks() {
      this.$store.dispatch("quick_task/getAllTask", [1, 0, null, null, null, {'key':'lead_id','id':this.$route.params.id}]);
    }
  }
};
</script>
